import { Provider } from 'react-redux';
import { store } from './store';
import ThemeProvider from './theme/ThemeProvider';
import Router from './router';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from './store';
import { CircularProgress } from '@mui/material';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<CircularProgress />} persistor={persistor}>
        <ThemeProvider>
          <Router />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
